module.exports = __webpack_public_path__ + "img/loons_04.b9663529.png";